export default {
    OPEN_ONLY: 'OPEN_ONLY',
    CLOSED_ONLY: 'CLOSED_ONLY',
    OPEN_AND_CLOSED: 'OPEN_AND_CLOSED'
};
